export default {
  name: 'InputText',
  props: ['field', 'modelValue', 'suggests'],
  emits: ['update:modelValue'],
  watch: {
    value: function value(_value) {
      this.$emit('update:modelValue', _value);
    }
  },
  data: function data() {
    return {
      value: this.modelValue
    };
  }
};